var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Ticket History ")]),
          _vm._l(_vm.posts, function(post, i) {
            return _c(
              "div",
              {
                key: "post-".concat(i)
              },
              [
                _c(
                  "gg-card-text",
                  {
                    class: post.staff ? "reply-admin" : ""
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "subtitle-2"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-bold"
                                  },
                                  [_vm._v(" " + _vm._s(post.fullname) + " ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "reply-email font-weight-bold"
                                  },
                                  [_vm._v("(" + _vm._s(post.email) + ")")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "d-none d-sm-inline"
                                  },
                                  [_vm._v(" on " + _vm._s(post.dateline) + " ")]
                                ),
                                post.staff
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "admin-chip mb-1 primary-color"
                                      },
                                      [_vm._v(" (GreenGeeks Staff) ")]
                                    )
                                  : _vm._e(),
                                post.staff
                                  ? _c("feedback", {
                                      attrs: {
                                        post: post
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex d-sm-none pt-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "b-block mb-2 text-right"
                              },
                              [_vm._v(" on " + _vm._s(post.dateline) + " ")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-card-text", {
                  staticClass: "post-white-space fs-15",
                  domProps: {
                    innerHTML: _vm._s(_vm.sanitize(post.contents))
                  }
                }),
                post.attachments.length
                  ? _c(
                      "v-card-actions",
                      _vm._l(post.attachments, function(attachment, index) {
                        return _c(
                          "gg-btn",
                          {
                            key: index,
                            attrs: {
                              tertiary: ""
                            },
                            on: {
                              click: function click($event) {
                                return _vm.downloadAttachment(
                                  attachment.attachmentid
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  size: "18"
                                }
                              },
                              [_vm._v("mdi-paperclip")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "text-none"
                              },
                              [
                                _vm._v(
                                  _vm._s(attachment.filename) +
                                    " (" +
                                    _vm._s(
                                      _vm.humanFileSize(attachment.filesize)
                                    ) +
                                    ")"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c("hr", {
                  staticClass: "mr-3 ml-3"
                })
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }